export default __webpack_public_path__ + "static/media/lock.e7d855ca.svg";